import Vue from 'vue';

const ACTIVITY_BUS_EVENTS = {
    SET_CURRENT_ACTIVITY: 'SET_CURRENT_ACTIVITY',
    BACK_SCROLL_TO_ACTIVITY: 'BACK_SCROLL_TO_ACTIVITY',
    DELETE_ACTIVITY: 'DELETE_ACTIVITY',
    ACTIVITY_POST_CREATED: 'ACTIVITY_POST_CREATED',
    LIKE_ACTIVITY: 'LIKE_ACTIVITY',
    COMMENT_ACTIVITY: 'COMMENT_ACTIVITY',
    REPLY_COMMENT: 'REPLY_COMMENT',
};

const activityEventsBus = new Vue({});

export {activityEventsBus, ACTIVITY_BUS_EVENTS};